import React from "react";
import { motion } from "framer-motion";
import { HoloCard } from "@/components/Holo";

const ITEMS = [
  "Neural Systems Active",
  "Character Memory Synced",
  "Campaign Database Connected",
  "Credit Shield Enabled",
];

export const SystemStatus = () => {
  return (
    <HoloCard accent="green" className="mt-10 p-5 max-w-md relative overflow-hidden" testid="system-status">
      <div className="neon-sweep" style={{ opacity: 0.5 }} />
      <div className="flex items-center justify-between mb-4">
        <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em] text-white/50">System Status</span>
        <span className="font-mono-tech text-[10px] uppercase text-neon-green animate-blink">● Live</span>
      </div>
      <div className="space-y-2.5">
        {ITEMS.map((t, i) => (
          <motion.div key={t} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.7 + i * 0.18 }}
            className="flex items-center justify-between font-mono-tech text-[11px]" data-testid={`status-${i}`}>
            <span className="flex items-center gap-2 text-white/70">
              <span className="w-1.5 h-1.5 rounded-full bg-neon-green animate-pulse-glow" style={{ boxShadow: "0 0 8px #39ff14" }} />
              {t}
            </span>
            <span className="text-neon-green">OK</span>
          </motion.div>
        ))}
      </div>
    </HoloCard>
  );
};
